import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { OnOffProgramProgressionEntity } from "@modules/programs/entities/onOffProgramProgressionEntity"
import {
  type OnOffProgramProgressionDto,
  OnOffProgramProgressionDtoSchema,
} from "@modules/programs/gateway/onOffProgramProgressionDto"
import { type ProgramOnOffApiGateway } from "@modules/programs/gateway/programOnOffApiGateway"
import {
  type OnOffSubscriptionDto,
  OnOffSubscriptionDtoSchema,
  type StripeOnOffProgramSubscriptionDto,
  StripeOnOffProgramSubscriptionDtoSchema,
} from "@modules/programs/gateway/programOnOffDto"

export class ProgramOnOffApi implements ProgramOnOffApiGateway {
  private baseUrl = "/programs/on-off"

  constructor(private api: ApiClient) {}

  async getProgressionsProgramOnOff(id: string): Promise<OnOffProgramProgressionEntity> {
    const resultDto = await this.api.get<OnOffProgramProgressionDto>(`${this.baseUrl}/${id}/progressions`)
    return OnOffProgramProgressionEntity.fromDto(resultDto.data)
  }

  // TODO : waiting backend for refacto return type (HUD2-839)
  async publishProgramOnOff(programId: string) {
    await this.api.post<void>(`${this.baseUrl}/${programId}/publish`)
  }

  async getProgramOnOffStripeSubscriptionInfos(programId: string) {
    const resultDto = await this.api.get<StripeOnOffProgramSubscriptionDto | null>(
      `${this.baseUrl}/${programId}/subscription`,
    )
    return resultDto.data ? LoggerService.parseApiDto(StripeOnOffProgramSubscriptionDtoSchema, resultDto.data) : null
  }

  async subscribeProgramOnOff(programId: string) {
    const result = await this.api.post<OnOffSubscriptionDto>(`${this.baseUrl}/${programId}/subscribe`)
    return LoggerService.parseApiDto(OnOffSubscriptionDtoSchema, result.data)
  }

  async unsubscribeProgramOnOff(programId: string) {
    const result = await this.api.post<OnOffSubscriptionDto>(`${this.baseUrl}/${programId}/unsubscribe`)
    return LoggerService.parseApiDto(OnOffSubscriptionDtoSchema, result.data)
  }

  /* ***************************************************** */
  /*        on-off-program-progression-controller          */
  /* ***************************************************** */
  async startProgramOnOff(programId: string) {
    const resultDto = await this.api.post<OnOffProgramProgressionDto>(`${this.baseUrl}/${programId}/start`, {
      programId,
    })
    return LoggerService.parseApiDto(OnOffProgramProgressionDtoSchema, resultDto.data)
  }
  async stopProgramOnOff(programId: string) {
    const resultDto = await this.api.post<OnOffProgramProgressionDto>(`${this.baseUrl}/${programId}/stop`, {
      programId,
    })
    return LoggerService.parseApiDto(OnOffProgramProgressionDtoSchema, resultDto.data)
  }
  async restartProgramOnOff(programId: string) {
    const resultDto = await this.api.post<OnOffProgramProgressionDto>(`${this.baseUrl}/${programId}/restart`, {
      programId,
    })
    return LoggerService.parseApiDto(OnOffProgramProgressionDtoSchema, resultDto.data)
  }
}
